import React from 'react';

import { createSuspenseRoute, SECURE_CONFIG } from 'utils/SecureRoute';
import { Outlet } from 'react-router-dom';

import 'pages/maintenance-form/components/container/Containers.less';

// redux
import { useInjectReducer } from 'utils/common/injectedReducers';
import { useInjectSaga } from 'utils/common/injectSaga';
import reducer from './controllers/reducer';
import saga from './controllers/saga';
import { getParamsFromStoreRedux } from 'store/utils';

import * as actionsGlobal from '@redux/global/actions';

const key = 'memberList';

const { lazy } = React;

const MemberGridMain = lazy(
  () => import('pages/branded-members/views/member-grid-main/MemberGridMain')
);

const MemberGridAsset = lazy(
  () => import('pages/branded-members/views/member-grid-asset/MemberGridAsset')
);

const MemberGridNew = lazy(
  () => import('pages/branded-members/views/member-grid-new/MemberGridNew')
);

const MemberGridProduct = lazy(
  () =>
    import('pages/branded-members/views/member-grid-product/MemberGridProduct')
);

export const memberRoutes = [
  {
    index: true,
    element: createSuspenseRoute({
      secureConfig: SECURE_CONFIG.MEMBER,
      Component: MemberGridMain,
    }),
  },
  {
    path: 'new',
    element: createSuspenseRoute({
      secureConfig: SECURE_CONFIG.MEMBER,
      Component: MemberGridNew,
    }),
  },
];

export const memberSiblingRoutes = [
  {
    path: 'member-assets',
    element: createSuspenseRoute({
      secureConfig: SECURE_CONFIG.PRODUCT,
      Component: MemberGridAsset,
    }),
  },
  {
    path: 'member-products',
    element: createSuspenseRoute({
      secureConfig: SECURE_CONFIG.PRODUCT,
      Component: MemberGridProduct,
    }),
  },
];

const BrandedMember = () => {
  useInjectReducer({ key, reducer });
  useInjectSaga({ key, saga });

  return <Outlet />;
};

export default BrandedMember;
